
export default {
  name: "veiculos-table",
  components: {

  },
    props: {
      rows: {
        type: Array,
        default: () => {
          [];
        },
      },
      getVeiculo: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      },
      salvarVeiculo: {
        type: Function,
        required: true // Isso garante que a função deve ser passada como prop
      }
    },
    data() {
      return {
        por_pagina : false,
        isLast: false,
      }
    },
    setup(props:any) {
      // Acessando as props diretamente sem usar `this`
      const getVeiculo = (row: any) => {
          props.getVeiculo(row); // Define o novo cen tro do mapa
      };

      const salvarVeiculo = (veiculo: any) => {
          props.salvarVeiculo(veiculo); // Define o novo cen tro do mapa
      };
      // Retorna os métodos ou variáveis que você quer expor
      return {
        getVeiculo,
        salvarVeiculo
      };
    }
};
